var vskoTextArea =  angular.module('vskoTextArea', []);

vskoTextArea.directive('vskoTextArea', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-text-area.html'),
    required: ['ngModel'],
    scope: {
      ngModel: '=',
      ngDisabled: '=',
      rows: '@'
    }
  }
}]);
